import { Panel } from "@/components/Panel";
import PanelCard from "@/components/PanelCard";
import { ContactForm } from "@/forms/ContactForm";
import ContactUs2 from "@/forms/ContactUs2";

export default function ContactPanel() {
  return (
    <div className="flex items-center justify-center max-w-3xl mx-auto">
      {/* <Panel title="ContactUs">
        <ContactForm />
      </Panel> */}
      <PanelCard title="Contact Us">
        <ContactUs2 />
      </PanelCard>
    </div>
  );
}
